<script>
    import Foot from "../components/Foot.svelte";
    import AdminBar from "../components/AdminBar.svelte";
</script>

<AdminBar/>

<main class="page-main">
    <h1>Goosicorn Admin</h1>
    <div class="goose-try-hard">
    </div>
</main>

<Foot/>

<style>
    main {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .goose-try-hard {
        user-select: none;
        margin: 0 auto;
        background-image: url("../assets/tryhard-goosicorn.svg");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 60px;
        width: 300px;
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>
